import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AdditionalInfoService } from '@app/_core/services/additional-info.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfigService } from '@app/config.services';
import { MessageDialogComponent } from '@app/pages/common/message-dialog/message-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html',
  styleUrl: './claims.component.scss'
})
export class ClaimsComponent {
  displayClaimInfo:boolean=false
    modalRef:BsModalRef
    @Input() FieldsConf:any
    @Input() ReadOnly:boolean    
    claimSearchData:Claims;
    claimData: any=[];
    sortOrder: string='Asc';
    showTabularData: boolean=false;
    currentpage:number=0;
    User: any;
    Company: any;
    maxdate:Date=new Date();
    ClaimMemberName: any;
    fieldDetails: any[]=[];
    mappedDetails: any={};
    constructor(private http: HttpClient,private managerService: ManagerService, private modalService: BsModalService,
      private loaderService:LoaderService,
      private configService:ConfigService,
      private additionalinfoService:AdditionalInfoService,
      private webStorageService: WebStorageService,
      @Inject(APP_BASE_HREF) public baseHref: string) {
      this.claimSearchData=new Claims()
    }
    ngAfterViewInit(): void {
      
    }
  
    async ngOnInit(): Promise<void> {
      this.User = this.webStorageService.getItemFromSessionStorage('currentUser');
      this.Company = this.webStorageService.getItemFromSessionStorage('company');
      console.log("ClaimInfo:",this.FieldsConf);
      this.fetchAndLoadData();
      if(this.FieldsConf && this.FieldsConf["Groups"] && (this.FieldsConf["Groups"].length<=0))
      {
        // let data:any =await this.readFieldsConfigSample();
        //let data:any =await this.configService.readFileContent('/assets/sampleFieldsConfClaimsInfo.json');
        let data:any =await this.configService.readFileContent('/assets/claims-fields.json');
        this.loaderService.display(false);
        // if(data && "Groups" in data && "Fields" in data["Groups"][0]){
        //   this.FieldsConf["Groups"]=data["Groups"];
        // }
        if(data && data.length>0)
        {
          this.fieldDetails=data
        }
      }
    }
    
    fetchAndLoadData()
    {
      this.claimSearchData=this.additionalinfoService.getClaimSearchData();
      if(!this.claimSearchData){
        this.claimSearchData=new Claims();
      }
      this.claimData=this.additionalinfoService.getClaimTabularData();
      let claimInfoData=this.additionalinfoService.getClaimInfoData();
      if(claimInfoData)
      {
        this.showTabularData=false;
        this.displayClaimInfo=true;
        this.mapClaimDetails(claimInfoData);
      }
      else if(this.claimData){
        if(this.claimData.length>1)
        {
          this.displayClaimInfo=false;
          this.showTabularData=true;
        }
      }
    }

    clearSearchResults()
    {
      this.displayClaimInfo=false;
      this.showTabularData=false;
      this.claimSearchData=new Claims();
      this.additionalinfoService.setClaimInfoData(null);
      this.additionalinfoService.setClaimTabularData(null);
      this.additionalinfoService.setClaimSearchData(null);
    }

    claimInfoSearchData():boolean{
      if(this.claimSearchData.CarrierMemberId.trim()==''&& this.claimSearchData.ClaimId.trim()==''&&
      this.claimSearchData.ProviderId.trim()==''&&this.claimSearchData.ProviderNPI.trim()=='')
      {
        return false;
      }
      return true;
    }
    // claimInfoSearchData():b.oolean
    // {
    //   for (const key in this.claimSearchData)
    //     {
    //       let value=this.claimSearchData[key];
    //       if(value!=="" && value!==null && value!==undefined )
    //       {
    //         return true;
    //       }
    //     }
    //     return false;
    // }

    claimInfoSearchPayload(searchData)
    {
      let payload:any={}
      payload.method='GetClaim';
      payload.user=this.User;
      payload.company=this.Company;
      payload.parameters=searchData;
      payload.parameters.DateFrom=searchData?.DateFrom?this.additionalinfoService.getFormattedDate(searchData?.DateFrom):'';
      payload.parameters.DateTo=searchData?.DateTo?this.additionalinfoService.getFormattedDate(searchData?.DateTo):'';
      return payload;
    }

    async search()
    {
      this.displayClaimInfo=false;
      let dataAvailable:boolean=this.claimInfoSearchData();
      if(dataAvailable){
      let claimInfoData:any;
      //claimInfoData=await this.managerService.getClaimInformation(this.claimSearchData)
        this.additionalinfoService.getAdditionalInfo(this.claimInfoSearchPayload(this.claimSearchData)).subscribe(claimInfoData=>{
        // if(!claimInfoData)
        // {
        //   claimInfoData=await this.configService.readFileContent('/assets/Sample/MultipleClaimsInfo.json')
        //   this.loaderService.display(false);
        // }
        if(claimInfoData && "Response" in claimInfoData && "Status" in claimInfoData["Response"] && claimInfoData["Response"]['Status']==1){
          if(claimInfoData && "Response" in claimInfoData && "Data" in claimInfoData["Response"] && claimInfoData["Response"]['Data'])
            {
              this.claimData=JSON.parse(claimInfoData["Response"]["Data"]);
              this.additionalinfoService.setClaimSearchData(this.claimSearchData);
              if(this.claimSearchData.ClaimId.trim()!==''){
                this.displayClaimInfo=true;
                this.additionalinfoService.setClaimInfoData(this.claimData);
                this.mapClaimDetails(this.claimData);
              }
              else{
                this.showTabularData=true;
                this.additionalinfoService.setClaimTabularData(this.claimData);
              }
            }
            else
            {
              this.showModalDialog("No records found for the provided search criteria.");
            }
        }
        else
        {
          this.showModalDialog("No records found for the provided search criteria.");
        }
        
      })
    }
    else
    {
      this.showModalDialog("Please enter a valid Carrier Member ID, Claim ID, Provider ID and/or Provider NPI.");
    }
    }
    showModalDialog(messageText)
    {
      const initialState = { message:messageText};
      const config: ModalOptions = { class: 'modal-sm modal-dialog-centered', ignoreBackdropClick:true, keyboard:false ,initialState:initialState};
      
      this.modalRef = this.modalService.show(MessageDialogComponent,config);
      //this.modalRef.content.event.subscribe((result: any) => {});
    }
    mapClaimsInfoFieldValues(claimInfoData)
    {
      this.FieldsConf.Groups.forEach(group => {
        group.Fields.forEach(field => {
          field["value"] = claimInfoData[0][field["Name"]];
        });
      });
      let temp=this.FieldsConf.Groups[0].Fields.filter(field=>field.Name=='MemberFullName')
      console.log("temp",temp);
      if(temp &&temp.length>0)
      {
        this.ClaimMemberName=temp[0]['value']
      }
    }
    mapClaimDetails(claimInfoData){
      this.mappedDetails=[]
      this.fieldDetails.forEach(field=>{
        let data=
        this.mappedDetails[field['label']]= claimInfoData[0][field["key"]]
        if(field['key']=='MemberFullName')
        {
          this.ClaimMemberName=claimInfoData[0][field["key"]]
        }
        if(field['key']=='ClaimDrg' && claimInfoData[0][field["key"]]){
          this.mappedDetails[field['label']]=claimInfoData[0][field["key"]]['FinalDrg']
        }
      })
      console.log("mappedDetails",this.mappedDetails.length,this.mappedDetails)
    }

    sortByName(colName)
    {
      if(this.sortOrder==='Asc')
      {
        this.claimData.sort((a,b)=>a[colName].localeCompare(b[colName]))
      }
      else
      {
        this.claimData.sort((a,b)=>b[colName].localeCompare(a[colName]))
      }
      this.sortOrder=this.sortOrder=='Asc'?'Desc':'Asc'
    }
    
  async getClaimInfo(filePath)
  {
    let InfoData:any=await this.configService.readFileContent(filePath)
    this.loaderService.display(false)
    if(InfoData && "Response" in InfoData && "Data" in InfoData["Response"]){
      return JSON.parse(InfoData["Response"]["Data"]);
    }
    return []
  }
  async onRowSelect(event:any)
  {
    let claimInfoData=[]
    console.log("RowSelected:",event.data)
    this.additionalinfoService.getAdditionalInfo(this.claimInfoSearchPayload({ClaimId: event.data.ClaimId})).subscribe(InfoData=>{
      if(InfoData && "Response" in InfoData && "Data" in InfoData["Response"] && InfoData["Response"]['Data']){
        claimInfoData= JSON.parse(InfoData["Response"]["Data"]);
      
        if(claimInfoData?.length>0)
          {
            this.showTabularData=false
            this.displayClaimInfo=true;
            this.additionalinfoService.setClaimInfoData(claimInfoData)
            this.mapClaimDetails(claimInfoData);
          }
          else{
            this.showModalDialog("Details not found for selected record.");
          }
        }
        else{
          this.showModalDialog("Details not found for selected record.");
        }
     });
    //}
    }
  navBack()
  {
    this.showTabularData=true;
    this.displayClaimInfo=false
    this.additionalinfoService.setClaimInfoData(null)
  }

  onPageChange(event)
  {
    console.log("CurrentPage",this.currentpage)
    console.log(event)
  }
  
}
class Claims{
  CarrierMemberId:string='';
  ClaimId:string='';
  ProviderId:string='';
  ProviderNPI:string='';
  DateFrom:string='';
  DateTo:string='';
}
